<template>
  <validation-observer
    ref="validationObserver"
    v-slot="{ invalid }"
  >
    <b-modal
      id="userAdd-modal"
      cancel-title="Annulla"
      cancel-variant="outline-secondary"
      centered
      ok-title="Aggiungi"
      title="Aggiungi Utente"
      :ok-disabled="invalid"
      @ok="register"
      @show="reset"
    >

      <b-form>
        <MyLoading :loading-show="loadingShow" />
        <b-form-group>
          <label for="login-name">Nome:</label>
          <ValidationProvider
            #default="{ errors }"
            name="Name"
            rules="required"
          >
            <b-form-input
              id="login-name"
              v-model="name"
              placeholder="Nome"
              type="text"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </b-form-group>
        <b-form-group>
          <label for="login-name">Mail:</label>
          <ValidationProvider
            #default="{ errors }"
            name="Email"
            rules="required|email"
          >
            <b-form-input
              id="login-name"
              v-model="userEmail"
              placeholder="Mail"
              type="text"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validationprovider>
        </b-form-group>
        <b-form-group>
          <label
            for="shareSelect"
          >Ruolo:</label>
          <ValidationProvider
            #default="{ errors }"
            name="Role"
            rules="required"
          >
            <b-form-select
              id="shareSelect"
              v-model="roleId"
              :options="groupsList"
            >
              <template #first>
                <b-form-select-option
                  :value="null"
                  disabled
                >
                  -- Seleziona un ruolo --
                </b-form-select-option>
                <small class="text-danger">{{ errors[0] }}</small>
              </template>
            </b-form-select>
          </ValidationProvider>
        </b-form-group>

      </b-form>

    </b-modal>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormSelectOption,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import authRepository from '@/api/authRepository'
import MyLoading from '@/layouts/components/MyLoading.vue'

export default {
  name: 'Modal',
  components: {
    MyLoading,
    ValidationObserver,
    ValidationProvider,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
  },
  props: {
    groupsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      name: '',
      userEmail: '',
      roleId: null,
      required,
      email,
      loadingShow: false,
    }
  },
  mounted() {
  },
  methods: {
    async register() {
      // event.preventDefault()
      this.loadingShow = true
      const { data } = await authRepository.register(this.name, this.userEmail, this.roleId)
      this.loadingShow = false

      if (data.code) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Utente aggiunto. Dovrebbe aver ricevuto le istruzioni per accedere.',
            icon: 'CheckIcon',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
      }
      this.$emit('reload')
      // this.close()
    },
    reset() {
      this.name = ''
      this.roleId = null
      this.userEmail = ''
      this.loadingShow = false
    },
    close() {
      this.$bvModal.hide('userAdd-modal')
    },
  },
}
</script>

<style>
[dir="ltr"] .modal-header .close {
  margin: -0.5rem -0.6rem -0.5rem auto;
}
</style>
